declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

const STEP_NAMES = ['pakket', 'gegevens', 'woning', 'planning', 'overzicht'] as const

export function wizardStepName(n: number): string {
  return STEP_NAMES[n - 1] || `step_${n}`
}

export function trackWizardEvent(name: string, params: Record<string, unknown> = {}): void {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  window.gtag('event', name, { flow: 'offerte_wizard', ...params })
}
